module.exports = __webpack_public_path__ + "img/cooperate3.c9ee9437.png";